import { useEffect, useRef, useState } from 'react';

const FLASH_DURATION_MS = 2000;

function useSaveFlash () {
    const [saved, setSaved] = useState(false);
    const timeoutRef = useRef(null);

    useEffect(() => () => clearTimeout(timeoutRef.current), []);

    function flashSaved () {
        clearTimeout(timeoutRef.current);
        setSaved(true);
        timeoutRef.current = setTimeout(() => setSaved(false), FLASH_DURATION_MS);
    }

    return { saved, flashSaved };
}

export default useSaveFlash;
